export enum FundingInputName {
  BankAccountNumber = 'account_number',
  ConfirmBankAccountNumber = 'confirm_account_number',
  RoutingNumber = 'routing_number',
  ConfirmRoutingNumber = 'confirm_routing_number',
}
